export enum TagObjectType {
  CUSTOMER = "CUSTOMER",
  SUPPLIER = "SUPPLIER",
  INVOICE = "INVOICE",
  OFFER = "OFFER",
  PROJECT = "PROJECT",
  EMPLOYEE = "EMPLOYEE",
  CONTACT = "CONTACT",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  ARTICLE = "ARTICLE",
  CONTRACT_INVOICE = "CONTRACT_INVOICE",
  INTERVENTION = "INTERVENTION",
  WORK_TEAM = "WORK_TEAM",
  CONTRACT = "CONTRACT",
}

/** Libellés des modules étiquetables, dans l'ordre d'affichage de l'écran admin. */
export const TAG_OBJECT_TYPE_LABELS: Record<TagObjectType, string> = {
  [TagObjectType.CUSTOMER]: "Clients",
  [TagObjectType.CONTACT]: "Contacts",
  [TagObjectType.SUPPLIER]: "Fournisseurs",
  [TagObjectType.OFFER]: "Offres",
  [TagObjectType.PROJECT]: "Chantiers",
  [TagObjectType.CONTRACT]: "Contrats",
  [TagObjectType.INVOICE]: "Factures",
  [TagObjectType.CONTRACT_INVOICE]: "Factures de contrat",
  [TagObjectType.PURCHASE_ORDER]: "Bons de commande",
  [TagObjectType.ARTICLE]: "Articles",
  [TagObjectType.INTERVENTION]: "Interventions",
  [TagObjectType.EMPLOYEE]: "Collaborateurs",
  [TagObjectType.WORK_TEAM]: "Équipes de travail",
};

export const ALL_TAG_OBJECT_TYPES = Object.keys(TAG_OBJECT_TYPE_LABELS) as TagObjectType[];

/** {tag_id: {OBJECT_TYPE: nombre d'objets étiquetés}} */
export type TagsUsage = Record<string, Partial<Record<TagObjectType, number>>>;

export class Tag {
  public tag_id = "";
  public eva_company_id = "";
  public name = "";
  public color = "";
  /** Modules sur lesquels l'étiquette peut être posée (liste complète = tous). */
  public allowed_object_types: TagObjectType[] = [...ALL_TAG_OBJECT_TYPES];

  constructor() {
    this.color = "#6894d4";
  }

  public static createInstance(jsonData: any): Tag {
    const tag = Object.assign(new Tag(), jsonData);
    // Réponse sans le champ (back antérieur) : autorisée partout.
    tag.allowed_object_types = jsonData?.allowed_object_types ?? [...ALL_TAG_OBJECT_TYPES];
    return tag;
  }

  public static createInstances(jsonData: any[]): Tag[] {
    return jsonData.map(Tag.createInstance);
  }

  public isAllowedOn(objectType: TagObjectType | null | undefined): boolean {
    return !objectType || this.allowed_object_types.includes(objectType);
  }

  public getFormErrors(tag: Tag): string[] {
    let errors = [];

    if (tag.name.trim() === "") {
      errors.push("Le nom du tag ne doit pas être vide.");
    }

    return errors;
  }
}
